export type GeoSuburbModel = {
  active?: boolean,
  cache_key: number,
  geo_state_id: number,
  id: number,
  latitude?: string,
  longitude?: string,
  post_code: string,
  title: string,
}

const state = {
  active: true,
  geo_state_id: undefined,
  id: null,
  latitude: '',
  longitude: '',
  post_code: '',
  title: '',
}

export const requiredFields = [
  { key: 'geo_state_id' },
  { key: 'post_code' },
  { key: 'title' },
]

export default state
